import {Avatar, type AvatarProps} from '@mui/material';
import type {UserBase} from 'types';
import {getUserInitials, getUserFullName, stringToColor} from 'utils';

export type ContactAvatarProps = AvatarProps & {
  contact: UserBase
};

const ContactAvatar = ({contact, ...props} : ContactAvatarProps) : JSX.Element => {
  return (
    <Avatar sx={{bgcolor: stringToColor(getUserFullName(contact))}} {...props}>
      {getUserInitials(contact)}
    </Avatar>
  );
};

export default ContactAvatar;